module.exports = __webpack_public_path__ + "static/media/axiom_kanombe1.dd7f73d3.jpg";